export class HelperMethods {
    public static formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }
        return [year, month, day].join('-');
      }
      public static createArrayPassedOnTime(fromHour: number, fromMinutes: string, toHour: number, routeDetailList) {
        let x =  routeDetailList[0].interval; // minutes interval
        let timesWithInterval = [];
        if (fromHour === 0 && toHour === 5) {
           timesWithInterval = [];
        } else if (fromHour === 9 && toHour === 15 || fromHour === 19 && toHour === 23) { }
        // tslint:disable-next-line:one-line
        else {
           timesWithInterval = []; // time array
        }
        let fromMinute = Number(fromMinutes);
        let calcfromAditionalNumber = ((fromMinute * 40) / 100);
        // let floatNumber = fromHour + fromMinute
        let tt = Math.round((fromHour * 60) + calcfromAditionalNumber); // start time 6 * 60
        // loop to increment the time and push results in array
        for (let i = fromHour; tt <= toHour * 60; i++) {
          let hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
          let mm = (tt % 60); // getting minutes of the hour in 0-55 format
          timesWithInterval.push(('0' + (hh)).slice(-2) + ':' + ('0' + mm).slice(-2));
          tt = tt + x;
        }
         return timesWithInterval;
      }
      public static  createArrayPassedOnTimePerHoure(fromHour: number, toHour: number) {
        let x = 60; // minutes interval
        let allTime = [];
        if (fromHour === 0 && toHour === 5) {
          allTime = [];
        } else if (fromHour === 9 && toHour === 15 || fromHour === 19 && toHour === 23) { }
        // tslint:disable-next-line:one-line
        else {
          allTime = []; // time array
        }
        // let floatNumber = fromHour + fromMinute
        let tt = Math.round((fromHour * 60)); // start time 6 * 60
        // loop to increment the time and push results in array
        for (let i = fromHour; tt <= toHour * 60; i++) {
          let hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
          let mm = (tt % 60); // getting minutes of the hour in 0-55 format
          allTime.push(('0' + (hh)).slice(-2));
          tt = tt + x;
        }
        return allTime;
      }
      public static  getDateList(start: Date, end: Date, days: number[]): Date[] {
        let dates: Date[] = [];
        let stop = new Date(end);
        if (stop > new Date()) {
          stop = new Date();
        }
        stop.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        for (let i: Date = new Date(start); i <= stop; i.setDate(i.getDate() + 1)) {
          if (days.includes(i.getDay())) {
            dates.push(new Date(i));
          }
        }
        return dates;
      }
      public static removeElementFromStringArray(element: any, days) {
       days.forEach((value, index) => {
          // tslint:disable-next-line:curly
          if (value === element) days.splice(index, 1);
        });
      }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/Helpers/herlperMethods.ts